import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';
import { doc, deleteDoc, serverTimestamp, setDoc } from 'firebase/firestore';
import app, { db } from '../firebase';
import { showToast } from '../utils/toast';

const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;

function getTokenDocId(token) {
  return btoa(token)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/g, '');
}

async function getServiceWorkerRegistration() {
  if (!('serviceWorker' in navigator)) return null;
  const swUrl = `${process.env.PUBLIC_URL || ''}/firebase-messaging-sw.js`;
  return navigator.serviceWorker.register(swUrl);
}

export async function registerPushNotifications(userId) {
  if (!userId || !VAPID_KEY) return null;
  if (!('Notification' in window)) return null;

  const supported = await isSupported().catch(() => false);
  if (!supported) return null;

  let permission = Notification.permission;
  if (permission === 'default') {
    permission = await Notification.requestPermission();
  }
  if (permission !== 'granted') return null;

  const serviceWorkerRegistration = await getServiceWorkerRegistration();
  if (!serviceWorkerRegistration) return null;

  const messaging = getMessaging(app);
  const token = await getToken(messaging, {
    vapidKey: VAPID_KEY,
    serviceWorkerRegistration,
  });
  if (!token) return null;

  const tokenDocId = getTokenDocId(token);
  await setDoc(doc(db, 'users', userId, 'fcmTokens', tokenDocId), {
    token,
    platform: 'web',
    userAgent: navigator.userAgent,
    updatedAt: serverTimestamp(),
  }, { merge: true });

  return { token, tokenDocId };
}

export async function unregisterPushNotificationToken(userId, tokenDocId) {
  if (!userId || !tokenDocId) return;
  await deleteDoc(doc(db, 'users', userId, 'fcmTokens', tokenDocId)).catch(() => {});
}

export async function subscribeForegroundNotifications() {
  const supported = await isSupported().catch(() => false);
  if (!supported) return () => {};

  const messaging = getMessaging(app);
  return onMessage(messaging, (payload) => {
    const message = payload.notification?.body || payload.data?.message;
    if (message) {
      showToast({ message, type: 'info' });
    }
  });
}
